import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpenseApprovalStateClass } from './interfaces/ExpenseApprovalStateClass'
import moment from 'moment';

const initialState: ExpenseApprovalStateClass = {
    isLoading: false,
    status: 'idle',
    expenseApprovalList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: " ",
    recordsFiltered: 0,
    isAllUnChecked: true,
    optionTimeOffTypesValue: "00000000-0000-0000-0000-000000000000",
    optionTimeOffTypesText: "All",
    optionApproverEmployeeValue: "0",
    optionApproverEmployeeText: "All",
    optionProjectValue: "0",
    optionProjectText: "All",
    optionProjectTaskValue: "0",
    optionProjectTaskText: "All",
    optionApprovedValue: "-1",
    optionApprovedText: "Both",
    startExpenseApprovalDate: (() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate.toISOString();
    })(),
    endExpenseApprovalDate: new Date().toISOString(),
    timeOffTypesList: [],
    approverEmployeeList: [],
    CurrentCultureName: "",
    columnIndex: 0,
    direction: "asc",
    Employeesdata: [],
    Projectdata: [],
    includeDateRange: false,
    IsRemoveFilterSetting: true
}

interface IThunkApi {
    state: {
        expenseApproval: ExpenseApprovalStateClass;
    },
}
const GetApprovalType = (ApproverTypeId: number) => {
    let ApprovalType: string = "";
    if (ApproverTypeId == 1) {
        ApprovalType = "TeamLead";
    } else if (ApproverTypeId == 2) {
        ApprovalType = "ProjectManager";
    } else if (ApproverTypeId == 3) {
        ApprovalType = "SpecificEmployee";
    } else if (ApproverTypeId == 4) {
        ApprovalType = "SpecificExternalUser";
    } else if (ApproverTypeId == 5) {
        ApprovalType = "EmployeeManager";
    }
    return ApprovalType;
}

export const getAllExpenseEntryApprovalsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Expenses/V2/getAllExpenseEntryApprovals',
        async (arg, thunkApi) => {
            const { page, pageSize, start, Order, OrderDir, search, StartDate, EndDate, EmployeeValues, ProjectValues, includeDateRange, ApproverEmployeeId } = arg;
            let SearchParamsValues = `${ApproverEmployeeId},${includeDateRange},${StartDate},${EndDate}`;
            const response = await fetchAPI('api/V2/Expenses/AllExpenseEntryApprovals?SearchParamsValues=' + SearchParamsValues + '&ProjectValues=' + ProjectValues + '&EmployeeValues=' + EmployeeValues + '&page=' + page + '&pageSize=' + pageSize + '&start=' + start + '&Order=' + Order + '&OrderDir=' + OrderDir + '&search=' + search + '&StartDate=' + StartDate + '&EndDate=' + EndDate, 'Get', '', true, '');
            const json = await response.json();
            return json;
        }
    )

export const getAccountTimeOffTypesByAccountIdAndIsDisabledAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Expenses/V2/getAccountTimeOffTypesByAccountIdAndIsDisabled',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Expenses/TimeOffTypes', 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const getEmployeesForTimeOffApprovalAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Expenses/V2/getEmployeesForTimeOffApproval',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Expenses/ApproverEmployee', 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const addTimeOffApprovalsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Expenses/v2/addTimeOffApprovals",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Expenses/AddTimeOffApprovals", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const ApproveOrRejectSelectedAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Expenses/v2/ApproveSelected",
        async (arg, thunkApi) => {
            const { List, id, IncludeDateRange, ExpenseEntryStartDate, ExpenseEntryEndDate } = arg;
            const StartDate = moment(ExpenseEntryStartDate).format("YYYY-MM-DD");
            const EndDate = moment(ExpenseEntryEndDate).format("YYYY-MM-DD");
            let filteredList: any = [];
            let updatedList: any = [];
            if (id === "Approve") {
                filteredList = List.filter((item: any) => item.isSelected === 1 && item.Approved === true);
                updatedList = filteredList.map((item: any) => {
                    if (item.isSelected === 1 && item.Approved === true) {
                        const formattedExpenseSheetDate = item.ExpenseSheetDate
                            ? moment.parseZone(item.ExpenseSheetDate).format('YYYY-MM-DD')
                            : null;
                        return {
                            ...item, IsApprove: true, Rejected: false, ApprovalType: GetApprovalType(item.SystemApproverTypeId), IncludeDateRange: IncludeDateRange,
                            ExpenseEntryStartDate: StartDate, ExpenseEntryEndDate: EndDate, ExpenseSheetDate: formattedExpenseSheetDate,
                        }
                    }
                });
            }
            else {
                filteredList = List.filter((item: any) => item.isSelected === 1 && item.Rejected === true);
                updatedList = filteredList.map((item: any) => {
                    if (item.isSelected === 1 && item.Approved === true) {
                    const formattedExpenseSheetDate = item.ExpenseSheetDate
                        ? moment.parseZone(item.ExpenseSheetDate).format('YYYY-MM-DD')
                        : null;           
                    return {
                        ...item, IsApprove: false, Approved: false, ApprovalType: GetApprovalType(item.SystemApproverTypeId), IncludeDateRange: IncludeDateRange,
                        ExpenseEntryStartDate: StartDate, ExpenseEntryEndDate: EndDate, ExpenseSheetDate: formattedExpenseSheetDate 
                    }
                }
                });
            }
            const response = await fetchAPI("api/v2/Expenses/ExpenseEntryApprovalsNew", "PUT", updatedList, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const SingleApproveOrRejectAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Expenses/v2/SingleApproveOrReject",
        async (arg, thunkApi) => {
            const { List, id, IncludeDateRange, ExpenseEntryStartDate, ExpenseEntryEndDate } = arg;
            let updatedList: any = [];
            const StartDate = moment(ExpenseEntryStartDate).format("YYYY-MM-DD");
            const EndDate = moment(ExpenseEntryEndDate).format("YYYY-MM-DD");
            if (id === "Approve") {
                updatedList = List.map((item: any) => {
                    const formattedExpenseSheetDate = item.ExpenseSheetDate
                        ? moment.parseZone(item.ExpenseSheetDate).format('YYYY-MM-DD')
                        : null;
           
                    return {
                        ...item,
                        IsApprove: true,
                        ApprovalType: GetApprovalType(item.SystemApproverTypeId),
                        IncludeDateRange: IncludeDateRange,
                        ExpenseEntryStartDate: StartDate,
                        ExpenseEntryEndDate: EndDate,
                        ExpenseSheetDate: formattedExpenseSheetDate 
                    };
                });
            }
            else {               
                updatedList = List.map((item: any) => {
                    const formattedExpenseSheetDate = item.ExpenseSheetDate
                        ? moment.parseZone(item.ExpenseSheetDate).format('YYYY-MM-DD')
                        : null;
           
                    return {
                        ...item,
                        IsApprove: false,
                        ApprovalType: GetApprovalType(item.SystemApproverTypeId),
                        IncludeDateRange: IncludeDateRange,
                        ExpenseEntryStartDate: StartDate,
                        ExpenseEntryEndDate: EndDate,
                        ExpenseSheetDate: formattedExpenseSheetDate 
                    };
                });
            }
            const response = await fetchAPI("api/v2/Expenses/ExpenseEntryApprovalsNew", "PUT", updatedList, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const ExpenseApprovalSlice = createSlice({
    name: 'timeEntryArchive',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.expenseApprovalList = [];
        },
        checkedState: (state, action) => {
            const currentindex = state.expenseApprovalList.findIndex((item) => item.AccountEmployeeExpenseSheetId == action.payload);
            const newArray = [...state.expenseApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1, 'Approved': true, 'Rejected': true };
            state.expenseApprovalList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expenseApprovalList.findIndex((item) => item.AccountEmployeeExpenseSheetId == action.payload);
            const newArray = [...state.expenseApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0, 'Approved': false, 'Rejected': false };
            state.expenseApprovalList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.expenseApprovalList.map((item) => ({
                ...item,
                isSelected: 1,
                'Approved': true,
                'Rejected': true
            }));
            state.expenseApprovalList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.expenseApprovalList.map((item) => ({
                ...item,
                isSelected: 0,
                'Approved': false,
                'Rejected': false
            }));
            state.expenseApprovalList = newArray;
        },
        setOptionTimeOffTypesValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionTimeOffTypesValue = value;
            state.optionTimeOffTypesText = label;
        },
        setOptionApproverEmployeeValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionApproverEmployeeValue = value;
            state.optionApproverEmployeeText = label;
        },
        setOptionProjectValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        setOptionProjectTaskValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectTaskValue = value;
            state.optionProjectTaskText = label;
        },
        setOptionApprovedValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionApprovedValue = value;
            state.optionApprovedText = label;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startExpenseApprovalDate = startDate;
            state.endExpenseApprovalDate = endDate;
            state.IsRemoveFilterSetting = true;
        },
        setComments: (state, action) => {
            const { Comments, AccountEmployeeExpenseSheetId } = action.payload;
            const currentindex = state.expenseApprovalList.findIndex((item) => item.AccountEmployeeExpenseSheetId == AccountEmployeeExpenseSheetId);
            const newArray = [...state.expenseApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], Comments: Comments };
            state.expenseApprovalList = newArray;
        },
        filterTimeOffApproval: (state, action) => {
            const { AccountTimeOffTypeId, TimeOffAccountEmployeeId, IncludeDateRange, StartDate, EndDate, AccountEmployeeId } = action.payload;
            const newArray = [...state.expenseApprovalList];
            newArray.forEach((item: any) => {
                if (
                    (TimeOffAccountEmployeeId != 0 ? (item.TimeOffAccountEmployeeId == TimeOffAccountEmployeeId) : true) &&
                    (AccountTimeOffTypeId != 0 ? (item.AccountTimeOffTypeId == AccountTimeOffTypeId) : true) && // Use single quotes around the GUID
                    (IncludeDateRange ? (moment(item.StartDate).format('MM-DD-YYYY') >= StartDate && moment(item.EndDate).format('MM-DD-YYYY') <= EndDate) : true) &&
                    item.AccountEmployeeId == AccountEmployeeId
                ) {
                    item.isFiltered = 1;
                }
                else {
                    item.isFiltered = 0;
                }
            });
            state.expenseApprovalList = newArray;
        },
        setSortConfig: (state, action) => {
            const { Index, Dir } = action.payload;
            state.direction = Dir;
            state.columnIndex = Index;

        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSearchValue: (state, action) => {

            state.search = action.payload;
            state.currentPage = 1;
        },
        setSelectedEmployee: (state, action) => {            
            const newState = [...state.Employeesdata];
            const { values } = action.payload;
            newState.forEach((item: any) => {
                item.isSelected = 0;
            });
            values.forEach((selectedValue: any) => {
                const selectedItem = newState.find(
                    (item: any) => item.value == selectedValue
                );
                if (selectedItem) {
                    selectedItem.isSelected = 1;
                }
            });
            state.Employeesdata = newState;
        },
        setSelectedProject: (state, action) => {
            const newState = [...state.Projectdata];
            const { values } = action.payload;
            newState.forEach((item: any) => {
                item.isSelected = 0;
            });
            values.forEach((selectedValue: any) => {
                const selectedItem = newState.find(
                    (item: any) => item.value == selectedValue
                );
                if (selectedItem) {
                    selectedItem.isSelected = 1;
                }
            });
            state.Projectdata = newState;
        },
        setIsIncludeDateRange: (state, action) => {
            state.includeDateRange = action.payload;
        },
        setIsRemoveFilterSetting: (state, action) => {
            state.IsRemoveFilterSetting = action.payload;;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllExpenseEntryApprovalsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAllExpenseEntryApprovalsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
                if (JSON.parse(payload.Data.data).length === 0) {
                    state.expenseApprovalList = [];
                } else {
                    state.expenseApprovalList = JSON.parse(payload.Data.data);
                    state.expenseApprovalList.map((item: any) => {                       
                        item.isSelected = 0
                        item.isFiltered = -1;
                        item.approvedButtonClass = 'btn-light-success btn-sm';
                        item.rejectedButtonClass = 'btn-light-danger btn-sm';
                        if (!item.hasOwnProperty('Comments')) {
                            item.Comments = "";
                            item.Approved = false;
                            item.Rejected = false;
                        }
                    });
                }
                state.selectedRecord = {};
                state.CurrentCultureName = payload.Data.CurrentCultureName;
                state.start = payload.Data.start
                state.currentPage = payload.Data.currentPage;
                state.totalItems = payload.Data.recordsTotal;
                state.recordsFiltered = payload.Data.recordsFiltered;
                if (state.IsRemoveFilterSetting == true) {
                    if (JSON.parse(payload.Data.Employeesdata).length === 0) {
                        state.Employeesdata = [];
                    }
                    else {
                        state.Employeesdata = JSON.parse(payload.Data.Employeesdata);
                        state.Employeesdata.map((item: any) => {
                            item.value = item.ExpenseEntryAccountEmployeeId;
                            item.label = item.EmployeeName;
                            item.isSelected = 0;
                        });
                    }

                    if (JSON.parse(payload.Data.Projectdata).length === 0) {
                        state.Projectdata = [];
                    }
                    else {
                        state.Projectdata = JSON.parse(payload.Data.Projectdata);
                        state.Projectdata.map((item: any) => {
                            item.value = item.Accountprojectid;
                            item.label = item.ProjectName;
                            item.isSelected = 0;
                        });
                    }
                }
            })
            .addCase(getAllExpenseEntryApprovalsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
                state.isReload = false;
            })
            .addCase(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = false
            })
            .addCase(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync.fulfilled, (state, { payload }) => {

                state.status = 'idle';
                payload.Data.map((item: any) => {
                    item.value = item.AccountTimeOffTypeId;
                    item.label = item.AccountTimeOffType;
                });
                payload.Data.unshift({ value: '0', label: 'All' })

                state.timeOffTypesList = payload.Data;
                state.isReload = false;
                state.isLoading = false;
                state.isLoading = false
            })
            .addCase(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
            })

            .addCase(getEmployeesForTimeOffApprovalAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = false
            })
            .addCase(getEmployeesForTimeOffApprovalAsync.fulfilled, (state, { payload }) => {

                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getEmployeesForTimeOffApprovalAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
            })

            .addCase(addTimeOffApprovalsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addTimeOffApprovalsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addTimeOffApprovalsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(ApproveOrRejectSelectedAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ApproveOrRejectSelectedAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(ApproveOrRejectSelectedAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
           
            .addCase(SingleApproveOrRejectAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(SingleApproveOrRejectAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(SingleApproveOrRejectAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
          
    }
})

export const {
    resetSelectedRecordObjectInState,
    setOptionApprovedValue, setOptionTimeOffTypesValue, setOptionApproverEmployeeValue, setOptionProjectTaskValue, setOptionProjectValue, setDateRangeValue, setComments,
    filterTimeOffApproval, checkedState, unCheckedState, checkedAllState, unCheckedAllState, setPageSize, setSortConfig, setSelectedEmployee, setSelectedProject, setIsIncludeDateRange, setIsRemoveFilterSetting
} = ExpenseApprovalSlice.actions
export const ExpenseApprovalState = (state: RootState) => state.timeOffApproval
export default ExpenseApprovalSlice.reducer